const {createSlice} = require('@reduxjs/toolkit');

const userDataSlice = createSlice({
    name: "userData",
    initialState: {
        userData: {
           username: null,
        },
    },
    reducers: {
        setUserData(state, action) {
            state.userData = {...state.userData, ...action.payload};
        },
        setUserName(state, action) {
            state.userData.username = action.payload;
        }
    },
});

export const {setUserData, setUserName} = userDataSlice.actions;
export default userDataSlice.reducer;
